<template>
  <share-buttons
    class="related-person-overlay-sharebar"
    :mode="sharebarMode"
    ref="shareButtons"
    :url="shareData.url"
    :shortenUrl="shareData.shortenUrl"
    :title="shareData.title"
    :class="[{active: mode === 'collapse', hide: mode !== 'collapse'}, `theme-${theme}`]"
    :gtmType="this.theme === 'desktop' ? 'gtmType_shareBtn-default':'gtmType_shareBtn-adhesiveBar'"></share-buttons>
</template>
<script>
  import ShareButtons from 'components/widgets/ShareButtons.vue'
  import get from 'lodash/get'
  import { mapGetters } from 'vuex'
  import { updateTitleByNodeType } from 'mixins/utilities'

  export default {
    name: 'related-person-share-bar',
    components: {
      ShareButtons,
    },
    props: {
      nid: [Number, String],
      overlayBody: {
        type: Object,
        default: () => ({}),
      },
      theme: {
        type: [String, Boolean],
        default: '',
      },
    },
    methods: {
      ...mapGetters(['requestDomain']),
    },
    computed: {
      shareData() {
        const obj = {
          url: `${this.requestDomain()}${get(this.node, 'relative_url', '')}`,
          shortenUrl: get(this.node, 'shorten_url', ''),
          title: updateTitleByNodeType({type: get(this, 'node.type', ''), originalTitle: get(this.node, 'title', '')}),
        }
        return obj
      },
      node() {
        return this.$store.getters.node(this.nid) || {}
      },
      sharebarMode() {
        return this.theme === 'desktop' ? 'inline' : 'sticky'
      },
      mode() {
        return this.theme === 'mobile' ? get(this, 'overlayBody.headerMode', '') : 'collapse'
      },
    },
  }
</script>

<style lang="scss">
  .related-person-overlay-sharebar.mode-inline.theme-desktop {
    .share-buttons-wrapper {
      flex-direction: column;
      a {
        width: rem-calc(50);
        height: rem-calc(50);
        // For Firefox
        min-height: rem-calc(50);
        background-color: rgba(0,0,0,0.5);
        border-radius: 50%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: rem-calc(16);

        &:hover {
          background: $rose;
        }
      }
      svg {
        display: flex;
        &.facebook {
          width: rem-calc(11);
          height: rem-calc(24);
        }
        &.email {
          width: rem-calc(22);
          height: rem-calc(16);
        }
      }
      a:hover > svg {
        fill: $share-hover-off !important;
      }
    }

  }
</style>

<style lang="scss" scoped>
  .related-person-overlay-sharebar {
    bottom: 0;
    position: fixed;
    transition: bottom .4s ease, transform .4s ease .02s;

    &.theme-desktop {
      top: 0;
      right: 0;
      /* width: 640px; */
      margin-right: rem-calc(565);
      margin-top: rem-calc(182);
    }

    &.active {
      bottom: 0;
    }
    &.hide {
      bottom: rem-calc(-50);
    }
  }
</style>



// WEBPACK FOOTER //
// ShareBar.vue?58364df2